import { render, staticRenderFns } from "./PurchasedUnit.vue?vue&type=template&id=6d210e10&scoped=true"
import script from "./PurchasedUnit.vue?vue&type=script&lang=js"
export * from "./PurchasedUnit.vue?vue&type=script&lang=js"
import style0 from "./PurchasedUnit.vue?vue&type=style&index=0&id=6d210e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d210e10",
  null
  
)

export default component.exports